import React, { useState } from "react";
import { Gallery } from "react-grid-gallery"; // ✅ Vérifie bien cet import
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Slide } from "react-awesome-reveal";

const images = [
  {
    src: `${process.env.PUBLIC_URL}/images/gal1.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal1.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal2.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal2.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal3.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal3.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal4.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal4.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal5.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal5.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal6.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal6.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal7.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal7.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal8.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal8.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal9.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal9.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal10.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal10.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal11.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal11.jpg`,
    width: 320,
    height: 212,
  },
  {
    src: `${process.env.PUBLIC_URL}/images/gal12.jpg`,
    thumbnail: `${process.env.PUBLIC_URL}/images/gal12.jpg`,
    width: 320,
    height: 212,
  },
];

function Galerie() {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  return (
    <section className="p-4 pb-0" id="travaux">
      <h3 className="text-2xl font-bold text-center mb-6">Nos Travaux</h3>
      <Slide delay={200} duration={2500} direction="right">
        {/* Galerie d'images */}
        <Gallery
          images={images}
          enableImageSelection={false}
          onClick={(index) => openLightbox(index)} // ✅ Fixé
        />

        {/* Lightbox */}
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={images.map((img) => ({ src: img.src }))}
          index={currentIndex}
        />
      </Slide>
    </section>
  );
}

export default Galerie; // ✅ Assure-toi que c'est bien exporté
